export const sdgs = {
  1: {
    id: 1,
    title: '*End poverty in all its forms everywhere*',
    short: 'No Poverty',
    colorInfo: {
      hex: '#e5243b',
      rgb: [229, 36, 59],
    },
    keywords: {
      tags: ['poverty'],
      descriptions: [
        'extreme poverty',
        'basic standard of living',
        'social protection',
      ],
      groups: ['poorest', 'vulnerable'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_1.png',
    targets: [
      {
        id: 1,
        sdgId: 1,
        externalId: 1,
        label:
          'By 2030, *eradicate extreme poverty for all people everywhere*, currently measured as people living on less than $1.25 a day',
      },
      {
        id: 2,
        sdgId: 1,
        externalId: 2,
        label:
          'By 2030, **reduce** at least by half the proportion of men, women and children of all ages living in *poverty* in all its dimensions according to national definitions',
      },
      {
        id: 3,
        sdgId: 1,
        externalId: 3,
        label:
          'Implement nationally *appropriate social protection systems and measures* for all, including floors, and by 2030 achieve substantial coverage of the poor and the vulnerable',
      },
      {
        id: 4,
        sdgId: 1,
        externalId: 4,
        label:
          'By 2030, ensure that all men and women, in particular the poor and the vulnerable, have *equal rights to economic resources*, as well as access to basic services, ownership and control over land and other forms of property, inheritance, natural resources, appropriate new technology and financial services, including microfinance',
      },
      {
        id: 5,
        sdgId: 1,
        externalId: 5,
        label:
          'By 2030, *build the resilience of the poor* and those in vulnerable situations and *reduce* their exposure and vulnerability to climate-related extreme events and other economic, social and environmental shocks and disasters',
      },
      {
        id: 6,
        sdgId: 1,
        externalId: 'a',
        label:
          'Ensure *significant mobilization of resources*from a variety of sources, including through enhanced development cooperation, in order to provide adequate and predictable means for developing countries, in particular least developed countries, to implement programmes and policies to end poverty in all its dimensions',
      },
      {
        id: 7,
        sdgId: 1,
        externalId: 'b',
        label:
          'Create sound policy frameworks at the national, regional and international levels, based on pro-poor and gender-sensitive development strategies, to support accelerated *investment in poverty eradication actions*',
      },
    ],
  },
  2: {
    id: 2,
    title:
      '*End hunger, achieve food security and improved nutrition and promote sustainable agriculture*',
    short: 'Zero Hunger',
    colorInfo: {
      hex: '#e5b735',
      rgb: [229, 183, 53],
    },
    keywords: {
      tags: ['hunger', 'food security', 'nutrition', 'sustainable agriculture'],
      descriptions: [
        'malnutrition',
        'food production',
        'agricultural productivity',
        'agricultural investments',
        'food markets',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_2.png',
    targets: [
      {
        id: 8,
        sdgId: 2,
        externalId: 1,
        label:
          'By 2030, *end hunger* and ensure access by all people, in particular the poor and people in vulnerable situations, including infants, to safe, nutritious and sufficient food all year round',
      },
      {
        id: 9,
        sdgId: 2,
        externalId: 2,
        label:
          'By 2030, *end all forms of malnutrition*, including achieving, by 2025, the internationally agreed targets on stunting and wasting in children under 5 years of age, and address the nutritional needs of adolescent girls, pregnant and lactating women and older persons',
      },
      {
        id: 10,
        sdgId: 2,
        externalId: 3,
        label:
          'By 2030, *double the agricultural productivity and incomes* of small-scale food producers, in particular women, indigenous peoples, family farmers, pastoralists and fishers, including through secure and equal access to land, other productive resources and inputs, knowledge, financial services, markets and opportunities for value addition and non-farm employment',
      },
      {
        id: 11,
        sdgId: 2,
        externalId: 4,
        label:
          'By 2030,* ensure sustainable food production systems* and implement resilient agricultural practices that increase productivity and production, that help maintain ecosystems, that strengthen capacity for adaptation to climate change, extreme weather, drought, flooding and other disasters and that progressively improve land and soil quality',
      },
      {
        id: 12,
        sdgId: 2,
        externalId: 5,
        label:
          'By 2020, *maintain the genetic diversity of seeds, cultivated plants* and farmed and domesticated animals and their related wild species, including through soundly managed and diversified seed and plant banks at the national, regional and international levels, and promote access to and fair and equitable sharing of benefits arising from the *utilization of genetic resources* and associated traditional knowledge, as internationally agreed',
      },
      {
        id: 13,
        sdgId: 2,
        externalId: 'a',
        label:
          'Increase investment, including through enhanced international cooperation, in rural infrastructure, agricultural research and extension services, technology development and plant and livestock gene banks in order to *enhance agricultural productive capacity* in developing countries, in particular least developed countries',
      },
      {
        id: 14,
        sdgId: 2,
        externalId: 'b',
        label:
          'Correct and* prevent trade restrictions and distortions in world agricultural markets*, including through the parallel elimination of all forms of agricultural export subsidies and all export measures with equivalent effect, in accordance with the mandate of the Doha Development Round',
      },
      {
        id: 15,
        sdgId: 2,
        externalId: 'c',
        label:
          'Adopt measures to *ensure the proper functioning of food commodity markets* and their derivatives and facilitate timely access to market information, including on food reserves, in order to help limit extreme food price volatility',
      },
    ],
  },
  3: {
    id: 3,
    title: '*Ensure healthy lives and promote well-being for all at all ages*',
    short: 'Good Health and Well-being',
    colorInfo: {
      hex: '#4c9f38',
      rgb: [76, 159, 56],
    },
    keywords: {
      tags: ['health', 'well-being'],
      descriptions: [
        'reproductive health',
        'maternal health',
        'child health',
        'epidemics',
        'communicable diseases',
        'non-communicable diseases',
        'environmental diseases',
        'universal health coverage',
        'medicines',
        'vaccines',
      ],
      groups: ['women', 'children'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_3.png',
    targets: [
      {
        id: 16,
        sdgId: 3,
        externalId: 1,
        label:
          'By 2030, **reduce* the global maternal mortality ratio* to less than 70 per 100,000 live births',
      },
      {
        id: 17,
        sdgId: 3,
        externalId: 2,
        label:
          'By 2030, *end preventable deaths of newborns and children* under 5 years of age, with all countries aiming to *reduce* neonatal mortality to at least as low as 12 per 1,000 live births and under-5 mortality to at least as low as 25 per 1,000 live births',
      },
      {
        id: 18,
        sdgId: 3,
        externalId: 3,
        label:
          'By 2030, *end the epidemics of AIDS, tuberculosis, malaria* and neglected tropical diseases and combat hepatitis, water-borne diseases and other communicable diseases',
      },
      {
        id: 19,
        sdgId: 3,
        externalId: 4,
        label:
          'By 2030, **reduce** by one third *premature mortality* from non-communicable diseases through prevention and treatment and promote mental health and well-being',
      },
      {
        id: 20,
        sdgId: 3,
        externalId: 5,
        label:
          'Strengthen the *prevention and treatment of substance abuse*, including narcotic drug abuse and harmful use of alcohol',
      },
      {
        id: 21,
        sdgId: 3,
        externalId: 6,
        label:
          'By 2020, *halve* the number of global *deaths and injuries from road traffic accidents*',
      },
      {
        id: 22,
        sdgId: 3,
        externalId: 7,
        label:
          'By 2030, *ensure universal access to sexual and reproductive health-care services*, including for family planning, information and education, and the integration of reproductive health into national strategies and programmes',
      },
      {
        id: 23,
        sdgId: 3,
        externalId: 8,
        label:
          '*Achieve universal health coverage*, including financial risk protection, access to quality essential health-care services and access to safe, effective, quality and affordable essential medicines and vaccines for all',
      },
      {
        id: 24,
        sdgId: 3,
        externalId: 9,
        label:
          'By 2030, substantially *reduce* the number of *deaths and illnesses* from hazardous chemicals and air, water and soil *pollution and contamination*',
      },
      {
        id: 25,
        sdgId: 3,
        externalId: 'a',
        label:
          'Strengthen the *implementation of the World Health Organization* *Framework Convention on Tobacco Control* in all countries, as appropriate',
      },
      {
        id: 26,
        sdgId: 3,
        externalId: 'b',
        label:
          '*Support the research and development of vaccines and medicines* for the communicable and non-communicable diseases that primarily affect developing countries, provide access to affordable essential medicines and vaccines, in accordance with the Doha Declaration on the TRIPS Agreement and Public Health, which affirms the right of developing countries to use to the full the provisions in the Agreement on Trade-Related Aspects of Intellectual Property Rights regarding flexibilities to protect public health, and, in particular, provide access to medicines for all',
      },
      {
        id: 27,
        sdgId: 3,
        externalId: 'c',
        label:
          'Substantially *increase health financing* and the recruitment, development, training and retention of the health workforce in developing countries, especially in least developed countries and small island developing States',
      },
      {
        id: 28,
        sdgId: 3,
        externalId: 'd',
        label:
          'Strengthen the capacity of all countries, in particular developing countries, for early warning, *risk reduction and management of national and global health risks*',
      },
    ],
  },
  4: {
    id: 4,
    title:
      '*Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all*',
    short: 'Quality Education',
    colorInfo: {
      hex: '#c5192d',
      rgb: [197, 25, 45],
    },
    keywords: {
      tags: ['education'],
      descriptions: [
        'skills',
        'technical education',
        'vocational educaiton',
        'training',
        'higher education',
        'knowledge',
        'values',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_4.png',
    targets: [
      {
        id: 29,
        sdgId: 4,
        externalId: 1,
        label:
          'By 2030, ensure that all girls and boys complete free, equitable and quality *primary and secondary education* leading to relevant and effective learning outcomes',
      },
      {
        id: 30,
        sdgId: 4,
        externalId: 2,
        label:
          'By 2030, ensure that all girls and boys have *access to* quality early childhood development, *care and pre-primary education* so that they are ready for primary education',
      },
      {
        id: 31,
        sdgId: 4,
        externalId: 3,
        label:
          'By 2030, ensure equal access for all women and men to affordable and quality technical, *vocational and tertiary education*, including university',
      },
      {
        id: 32,
        sdgId: 4,
        externalId: 4,
        label:
          'By 2030, substantially* increase the number of youth and adults who have relevant skills*, including technical and vocational skills, for employment, decent jobs and entrepreneurship',
      },
      {
        id: 33,
        sdgId: 4,
        externalId: 5,
        label:
          'By 2030, *eliminate gender disparities in education* and ensure equal access to all levels of education and vocational training for the vulnerable, including persons with disabilities, indigenous peoples and children in vulnerable situations',
      },
      {
        id: 34,
        sdgId: 4,
        externalId: 6,
        label:
          'By 2030, ensure that all youth and a substantial proportion of adults, both men and women, *achieve literacy and numeracy*',
      },
      {
        id: 35,
        sdgId: 4,
        externalId: 7,
        label:
          'By 2030, ensure that all learners *acquire the knowledge and skills* needed to promote sustainable development, including, among others, through education for sustainable development and sustainable lifestyles, human rights, gender equality, promotion of a culture of peace and non-violence, global citizenship and appreciation of cultural diversity and of culture’s contribution to sustainable development',
      },
      {
        id: 36,
        sdgId: 4,
        externalId: 'a',
        label:
          '*Build and upgrade education facilities* that are child, disability and gender sensitive and provide safe, non-violent, inclusive and effective learning environments for all',
      },
      {
        id: 37,
        sdgId: 4,
        externalId: 'b',
        label:
          'By 2020, substantially *expand globally the number of scholarships available* to developing countries, in particular least developed countries, small island developing States and African countries, for enrolment in higher education, including vocational training and information and communications technology, technical, engineering and scientific programmes, in developed countries and other developing countries',
      },
      {
        id: 38,
        sdgId: 4,
        externalId: 'c',
        label:
          'By 2030, substantially *increase the supply of qualified teachers*, including through international cooperation for teacher training in developing countries, especially least developed countries and small island developing States',
      },
    ],
  },
  5: {
    id: 5,
    title: '*Achieve gender equality and empower all women and girls*',
    short: 'Gender Equality',
    colorInfo: {
      hex: '#ff3a21',
      rgb: [255, 58, 33],
    },
    keywords: {
      tags: ['gender', 'women', 'girls'],
      descriptions: [
        'women empowerment',
        'girls empowerment',
        'discrimination against women',
        'violence against women',
        'sexual health',
        'reproductive health',
        'reproductive rights',
        'unpaid work',
        'access to productive resources',
        'equal participation',
        'political life',
        'economic life',
        'public life',
      ],
      groups: ['women', 'girls'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_5.png',
    targets: [
      {
        id: 39,
        sdgId: 5,
        externalId: 1,
        label:
          'End all forms of *discrimination against all women and girls* everywhere',
      },
      {
        id: 40,
        sdgId: 5,
        externalId: 2,
        label:
          '*Eliminate all forms of violence* against all women and girls in the public and private spheres, including trafficking and sexual and other types of exploitation',
      },
      {
        id: 41,
        sdgId: 5,
        externalId: 3,
        label:
          'Eliminate all harmful practices, such as child, early and *forced marriage* and female genital mutilation',
      },
      {
        id: 42,
        sdgId: 5,
        externalId: 4,
        label:
          'Recognize and value *unpaid care and domestic work* through the provision of public services, infrastructure and social protection policies and the promotion of shared responsibility within the household and the family as nationally appropriate',
      },
      {
        id: 43,
        sdgId: 5,
        externalId: 5,
        label:
          'Ensure women’s full and effective participation and *equal opportunities for leadership* at all levels of decision-making in political, economic and public life',
      },
      {
        id: 44,
        sdgId: 5,
        externalId: 6,
        label:
          'Ensure *universal access to sexual and reproductive health and reproductive rights* as agreed in accordance with the Programme of Action of the International Conference on Population and Development and the Beijing Platform for Action and the outcome documents of their review conferences',
      },
      {
        id: 45,
        sdgId: 5,
        externalId: 'a',
        label:
          'Undertake reforms to *give women equal rights to economic resources*, as well as access to ownership and control over land and other forms of property, financial services, inheritance and natural resources, in accordance with national laws',
      },
      {
        id: 46,
        sdgId: 5,
        externalId: 'b',
        label:
          'Enhance the use of enabling technology, in particular information and communications technology, to *promote the empowerment of women*',
      },
      {
        id: 47,
        sdgId: 5,
        externalId: 'c',
        label:
          'Adopt and strengthen sound policies and enforceable legislation for the *promotion of gender equality* and the empowerment of all women and girls at all levels',
      },
    ],
  },
  6: {
    id: 6,
    title:
      '*Ensure availability and sustainable management of water and sanitation for all*',
    short: 'Clean Water and Sanitation',
    colorInfo: {
      hex: '#26bde2',
      rgb: [38, 189, 226],
    },
    keywords: {
      tags: ['water', 'sanitation'],
      descriptions: [
        'drinking water',
        'hygiene',
        'water resources',
        'water management',
        'sanitation management',
      ],
      groups: ['international cooperation', 'local communities'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_6.png',
    targets: [
      {
        id: 48,
        sdgId: 6,
        externalId: 1,
        label:
          'By 2030, achieve universal and equitable *access to safe and affordable drinking water for all*',
      },
      {
        id: 49,
        sdgId: 6,
        externalId: 2,
        label:
          'By 2030, achieve access to adequate and equitable **sanitation and hygiene** for all and end open defecation, paying special attention to the needs of women and girls and those in vulnerable situations',
      },
      {
        id: 50,
        sdgId: 6,
        externalId: 3,
        label:
          'By 2030, *improve water quality* by reducing pollution, eliminating dumping and minimizing release of hazardous chemicals and materials, halving the proportion of untreated wastewater and substantially increasing recycling and safe reuse globally',
      },
      {
        id: 51,
        sdgId: 6,
        externalId: 4,
        label:
          'By 2030, substantially *increase water-use efficiency* across all sectors and ensure sustainable withdrawals and supply of freshwater to address water scarcity and substantially *reduce* the number of people suffering from water scarcity',
      },
      {
        id: 52,
        sdgId: 6,
        externalId: 5,
        label:
          'By 2030, implement integrated *water resources management* at all levels, including through transboundary cooperation as appropriate',
      },
      {
        id: 53,
        sdgId: 6,
        externalId: 6,
        label:
          'By 2020, protect and *restore water-related ecosystems*, including mountains, forests, wetlands, rivers, aquifers and lakes',
      },
      {
        id: 54,
        sdgId: 6,
        externalId: 'a',
        label:
          'By 2030, expand international cooperation and *capacity-building support to developing countries* in *water- and sanitation-related activities* and programmes, including water harvesting, desalination, water efficiency, wastewater treatment, recycling and reuse technologies',
      },
      {
        id: 55,
        sdgId: 6,
        externalId: 'b',
        label:
          'Support and strengthen the participation of local communities in improving *water and sanitation management*',
      },
    ],
  },
  7: {
    id: 7,
    title:
      '*Ensure access to affordable, reliable, sustainable and modern energy for all*',
    short: 'Affordable and Clean Energy',
    colorInfo: {
      hex: '#fcc30b',
      rgb: [252, 195, 11],
    },
    keywords: {
      tags: ['energy'],
      descriptions: ['energy access', 'renewable energy'],
      groups: ['international cooperation'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_7.png',
    targets: [
      {
        id: 56,
        sdgId: 7,
        externalId: 1,
        label:
          'By 2030, ensure universal access to *affordable, reliable and modern energy services*',
      },
      {
        id: 57,
        sdgId: 7,
        externalId: 2,
        label:
          'By 2030, increase substantially the *share of renewable energy* in the global energy mix',
      },
      {
        id: 58,
        sdgId: 7,
        externalId: 3,
        label:
          'By 2030, double the global rate of *improvement in energy efficiency*',
      },
      {
        id: 59,
        sdgId: 7,
        externalId: 'a',
        label:
          'By 2030, enhance international cooperation to facilitate *access to clean energy* research and technology, including renewable energy, energy efficiency and advanced and cleaner fossil-fuel technology, and promote investment in energy infrastructure and clean energy technology',
      },
      {
        id: 60,
        sdgId: 7,
        externalId: 'b',
        label:
          'By 2030, expand infrastructure and upgrade technology for *supplying modern and sustainable energy services* for all in developing countries, in particular least developed countries, small island developing States, and land-locked developing countries, in accordance with their respective programmes of support',
      },
    ],
  },
  8: {
    id: 8,
    title:
      '*Promote sustained, inclusive and sustainable economic growth, full and *productive employment and decent work* for all*',
    short: 'Decent Jobs and Economic Growth',
    colorInfo: {
      hex: '#a21942',
      rgb: [162, 25, 66],
    },
    keywords: {
      tags: ['economic growth', 'employment', 'decent work'],
      descriptions: ['forced labour', 'human trafficking', 'child labour'],
      groups: ['children'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_8.png',
    targets: [
      {
        id: 61,
        sdgId: 8,
        externalId: 1,
        label:
          'Sustain *per capita economic growth* in accordance with national circumstances and, in particular, at least 7 per cent gross domestic product growth per annum in the least developed countries',
      },
      {
        id: 62,
        sdgId: 8,
        externalId: 2,
        label:
          'Achieve *higher levels of economic productivity* through diversification, technological upgrading and innovation, including through a focus on high-value added and labour-intensive sectors',
      },
      {
        id: 63,
        sdgId: 8,
        externalId: 3,
        label:
          'Promote development-oriented policies that support productive activities, *decent job creation, entrepreneurship, creativity and innovation*, and encourage the formalization and growth of micro-, small- and medium-sized enterprises, including through access to financial services',
      },
      {
        id: 64,
        sdgId: 8,
        externalId: 4,
        label:
          'Improve progressively, through 2030, global resource efficiency in consumption and production and endeavour to *decouple economic growth from environmental degradation*, in accordance with the 10-year framework of programmes on *sustainable consumption and production*, with developed countries taking the lead',
      },
      {
        id: 65,
        sdgId: 8,
        externalId: 5,
        label:
          'By 2030, achieve full and *productive employment and decent work* for all women and men, including for young people and persons with disabilities, and equal pay for work of equal value',
      },
      {
        id: 66,
        sdgId: 8,
        externalId: 6,
        label:
          'By 2020, substantially *reduce the proportion of youth not in employment, education or training*',
      },
      {
        id: 67,
        sdgId: 8,
        externalId: 7,
        label:
          'Take immediate and effective measures to *eradicate forced labour, end modern slavery and human trafficking* and secure the prohibition and elimination of the worst forms of child labour, including recruitment and use of child soldiers, and by 2025 end child labour in all its forms',
      },
      {
        id: 68,
        sdgId: 8,
        externalId: 8,
        label:
          '*Protect labour rights and promote safe and secure working environments* for all workers, including migrant workers, in particular women migrants, and those in precarious employment',
      },
      {
        id: 69,
        sdgId: 8,
        externalId: 9,
        label:
          'By 2030, devise and implement policies to promote *sustainable tourism* that creates jobs and promotes local culture and products',
      },
      {
        id: 70,
        sdgId: 8,
        externalId: 10,
        label:
          'Strengthen the capacity of domestic financial institutions to encourage and expand *access to banking, insurance and financial services for all*',
      },
      {
        id: 71,
        sdgId: 8,
        externalId: 'a',
        label:
          '*Increase Aid for Trade support* for developing countries, in particular least developed countries, including through the Enhanced Integrated Framework for Trade-Related Technical Assistance to Least Developed Countries',
      },
      {
        id: 72,
        sdgId: 8,
        externalId: 'b',
        label:
          'By 2020, develop and operationalize a global strategy for *youth employment* and implement the Global Jobs Pact of the International Labour Organization',
      },
    ],
  },
  9: {
    id: 9,
    title:
      '*Build resilient infrastructure, promote inclusive and *sustainable industrialization* and foster innovation*',
    short: 'Industry, Innovation and Infrastructure',
    colorInfo: {
      hex: '#fd6925',
      rgb: [253, 105, 37],
    },
    keywords: {
      tags: ['infrastructure', 'industrialization', 'innovation'],
      descriptions: [
        'research',
        'technology',
        'technical support',
        'ICT',
        'information and communication technology',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_9.png',
    targets: [
      {
        id: 73,
        sdgId: 9,
        externalId: 1,
        label:
          'Develop quality, reliable, *sustainable and resilient infrastructure*, including regional and transborder infrastructure, to support economic development and human well-being, with a focus on affordable and equitable access for all',
      },
      {
        id: 74,
        sdgId: 9,
        externalId: 2,
        label:
          'Promote inclusive and *sustainable industrialization* and, by 2030, significantly raise industry’s share of employment and gross domestic product, in line with national circumstances, and double its share in least developed countries',
      },
      {
        id: 75,
        sdgId: 9,
        externalId: 3,
        label:
          'Increase the *access of small-scale industrial and other enterprises*, in particular in developing countries, to financial services, including affordable credit, and their integration into value chains and markets',
      },
      {
        id: 76,
        sdgId: 9,
        externalId: 4,
        label:
          'By 2030, upgrade infrastructure and retrofit industries to make them sustainable, with increased *resource-use efficiency* and greater *adoption of clean and environmentally sound technologies and industrial processes*, with all countries taking action in accordance with their respective capabilities',
      },
      {
        id: 77,
        sdgId: 9,
        externalId: 5,
        label:
          '*Enhance scientific research*, upgrade the technological capabilities of industrial sectors in all countries, in particular developing countries, including, by 2030, encouraging innovation and substantially increasing the number of research and development workers per 1 million people and public and private research and development spending',
      },
      {
        id: 78,
        sdgId: 9,
        externalId: 'a',
        label:
          'Facilitate sustainable and resilient *infrastructure development in developing countries* through enhanced financial, technological and technical support to African countries, least developed countries, landlocked developing countries and small island developing States',
      },
      {
        id: 79,
        sdgId: 9,
        externalId: 'b',
        label:
          'Support domestic technology development, *research and innovation* in developing countries, including by ensuring a conducive policy environment for, inter alia, industrial diversification and value addition to commodities',
      },
      {
        id: 80,
        sdgId: 9,
        externalId: 'c',
        label:
          'Significantly increase *access to information and communications technology* and strive to provide universal and affordable access to the Internet in least developed countries by 2020',
      },
    ],
  },
  10: {
    id: 10,
    title: '*Reduce inequality within and among countries*',
    short: 'Reduce Inequalities',
    colorInfo: {
      hex: '#dd1367',
      rgb: [221, 19, 103],
    },
    keywords: {
      tags: ['inequality'],
      descriptions: [
        'income',
        'sex',
        'age',
        'disability',
        'race',
        'class',
        'ethnicity',
        'religion',
        'migration',
        'development assistance',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_10.png',
    targets: [
      {
        id: 81,
        sdgId: 10,
        externalId: 1,
        label:
          'By 2030, progressively achieve and *sustain income growth* of the bottom 40 per cent of the population at a rate higher than the national average',
      },
      {
        id: 82,
        sdgId: 10,
        externalId: 2,
        label:
          'By 2030, empower and *promote the social, economic and political inclusion* of all, irrespective of age, sex, disability, race, ethnicity, origin, religion or economic or other status',
      },
      {
        id: 83,
        sdgId: 10,
        externalId: 3,
        label:
          'Ensure *equal opportunity and reduce inequalities* of outcome, including by eliminating discriminatory laws, policies and practices and promoting appropriate legislation, policies and action in this regard',
      },
      {
        id: 84,
        sdgId: 10,
        externalId: 4,
        label:
          'Adopt policies, especially fiscal, wage and social protection policies, and progressively *achieve greater equality*',
      },
      {
        id: 85,
        sdgId: 10,
        externalId: 5,
        label:
          'Improve the regulation and *monitoring of global financial markets* and institutions and strengthen the implementation of such regulations',
      },
      {
        id: 86,
        sdgId: 10,
        externalId: 6,
        label:
          'Ensure *enhanced representation and voice for developing countries* in decision-making in global international economic and financial institutions in order to deliver more effective, credible, accountable and legitimate institutions',
      },
      {
        id: 87,
        sdgId: 10,
        externalId: 7,
        label:
          'Facilitate orderly, safe, regular and *responsible migration* and mobility of people, including through the implementation of planned and well-managed migration policies',
      },
      {
        id: 88,
        sdgId: 10,
        externalId: 'a',
        label:
          'Implement the principle of special and differential treatment for developing countries, in particular least developed countries, in accordance with World Trade Organization agreements',
      },
      {
        id: 89,
        sdgId: 10,
        externalId: 'b',
        label:
          'Encourage official development assistance and financial flows, including *foreign direct investment, to States where the need is greatest*, in particular least developed countries, African countries, small island developing States and landlocked developing countries, in accordance with their national plans and programmes',
      },
      {
        id: 90,
        sdgId: 10,
        externalId: 'c',
        label:
          'By 2030, *reduce* to less than 3 per cent the *transaction costs of migrant remittances* and eliminate remittance corridors with costs higher than 5 per cent',
      },
    ],
  },
  11: {
    id: 11,
    title:
      '*Make cities and human settlements inclusive, safe, resilient and sustainable*',
    short: 'Sustainable Cities and Communities',
    colorInfo: {
      hex: '#fd9d24',
      rgb: [253, 157, 36],
    },
    keywords: {
      tags: ['cities', 'human settlements'],
      descriptions: [
        'community cohesion',
        'personal security',
        'innovation',
        'employment',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_11.png',
    targets: [
      {
        id: 91,
        sdgId: 11,
        externalId: 1,
        label:
          'By 2030, ensure access for all to adequate, *safe and affordable housing* and basic services and upgrade slums',
      },
      {
        id: 92,
        sdgId: 11,
        externalId: 2,
        label:
          'By 2030, provide access to safe, affordable, accessible and *sustainable transport systems for all*, improving road safety, notably by expanding public transport, with special attention to the needs of those in vulnerable situations, women, children, persons with disabilities and older persons',
      },
      {
        id: 93,
        sdgId: 11,
        externalId: 3,
        label:
          'By 2030, enhance inclusive and *sustainable urbanization* and capacity for participatory, integrated and sustainable human settlement planning and management in all countries',
      },
      {
        id: 94,
        sdgId: 11,
        externalId: 4,
        label:
          'Strengthen efforts to protect and *safeguard the world’s cultural and natural heritage*',
      },
      {
        id: 95,
        sdgId: 11,
        externalId: 5,
        label:
          'By 2030, significantly *reduce the number of deaths* and the number of people affected and substantially decrease the direct economic losses relative to global gross domestic product caused by disasters, including water-related disasters, with a focus on protecting the poor and people in vulnerable situations',
      },
      {
        id: 96,
        sdgId: 11,
        externalId: 6,
        label:
          'By 2030, reduce the adverse *per capita environmental impact of cities*, including by paying special attention to air quality and municipal and other waste management',
      },
      {
        id: 97,
        sdgId: 11,
        externalId: 7,
        label:
          'By 2030, provide universal access to safe, inclusive and accessible,*green and public spaces*, in particular for women and children, older persons and persons with disabilities',
      },
      {
        id: 98,
        sdgId: 11,
        externalId: 'a',
        label:
          'Support positive economic, social and environmental links between urban, per-urban and rural areas by strengthening *national and regional development planning*',
      },
      {
        id: 99,
        sdgId: 11,
        externalId: 'b',
        label:
          'By 2020, substantially increase the number of cities and human settlements adopting and implementing *integrated policies and plans towards inclusion*, resource efficiency, mitigation and adaptation to climate change, resilience to disasters, and develop and implement, in line with the Sendai Framework for Disaster Risk Reduction 2015-2030, holistic disaster risk management at all levels',
      },
      {
        id: 100,
        sdgId: 11,
        externalId: 'c',
        label:
          '*Support least developed countries*, including through financial and technical assistance, in building sustainable and resilient buildings utilizing local materials',
      },
    ],
  },
  12: {
    id: 12,
    title: '*Ensure *sustainable consumption and production* patterns*',
    short: 'Responsible Consumption and Production',
    colorInfo: {
      hex: '#c9992d',
      rgb: [201, 153, 45],
    },
    keywords: {
      tags: ['consumption', 'production'],
      descriptions: ['toxic materials', 'environment'],
      groups: ['international agreements'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_12.png',
    targets: [
      {
        id: 101,
        sdgId: 12,
        externalId: 1,
        label:
          'Implement the 10-year framework of programmes on *sustainable consumption and production*, all countries taking action, with developed countries taking the lead, taking into account the development and capabilities of developing countries',
      },
      {
        id: 102,
        sdgId: 12,
        externalId: 2,
        label:
          'By 2030, achieve the sustainable management and *efficient use of natural resources*',
      },
      {
        id: 103,
        sdgId: 12,
        externalId: 3,
        label:
          'By 2030, *halve* per capita global *food waste* at the retail and consumer levels and *reduce* food losses along production and supply chains, including post-harvest losses',
      },
      {
        id: 104,
        sdgId: 12,
        externalId: 4,
        label:
          'By 2020, achieve the *environmentally sound management of chemicals* and all wastes throughout their life cycle, in accordance with agreed international frameworks, and significantly *reduce* their release to air, water and soil in order to minimize their adverse impacts on human health and the environment',
      },
      {
        id: 105,
        sdgId: 12,
        externalId: 5,
        label:
          'By 2030, substantially *reduce waste generation* through prevention, reduction, recycling and reuse',
      },
      {
        id: 106,
        sdgId: 12,
        externalId: 6,
        label:
          'Encourage companies, especially large and transnational companies, to adopt *sustainable practices* and to integrate sustainability information into their reporting cycle',
      },
      {
        id: 107,
        sdgId: 12,
        externalId: 7,
        label:
          '*Promote public procurement practices that are sustainable*, in accordance with national policies and priorities',
      },
      {
        id: 108,
        sdgId: 12,
        externalId: 8,
        label:
          'By 2030, ensure that people everywhere have the relevant information and awareness for *sustainable development and lifestyles* in harmony with nature',
      },
      {
        id: 109,
        sdgId: 12,
        externalId: 'a',
        label:
          'Support developing countries to strengthen their scientific and technological capacity to move towards more *sustainable patterns of consumption and production*',
      },
      {
        id: 110,
        sdgId: 12,
        externalId: 'b',
        label:
          'Develop and implement tools to *monitor sustainable development impacts* for sustainable tourism that creates jobs and promotes local culture and products',
      },
      {
        id: 111,
        sdgId: 12,
        externalId: 'c',
        label:
          'Rationalize *inefficient fossil-fuel subsidies* that encourage wasteful consumption by removing market distortions, in accordance with national circumstances, including by restructuring taxation and phasing out those harmful subsidies, where they exist, to reflect their environmental impacts, taking fully into account the specific needs and conditions of developing countries and minimizing the possible adverse impacts on their development in a manner that protects the poor and the affected communities',
      },
    ],
  },
  13: {
    id: 13,
    title: '*Take urgent action to combat climate change and its impacts*.',
    short: 'Climate Action',
    colorInfo: {
      hex: '#3f7e44',
      rgb: [63, 126, 68],
    },
    keywords: {
      tags: ['climate change'],
      descriptions: ['resilience', 'natural disasters'],
      groups: ['poorest', 'vulnerable'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_13.png',
    targets: [
      {
        id: 112,
        sdgId: 13,
        externalId: 1,
        label:
          'Strengthen resilience and *adaptive capacity to climate-related hazards* and natural disasters in all countries',
      },
      {
        id: 113,
        sdgId: 13,
        externalId: 2,
        label:
          '*Integrate climate change measures* into national policies, strategies and planning',
      },
      {
        id: 114,
        sdgId: 13,
        externalId: 3,
        label:
          'Improve education, awareness-raising and human and institutional capacity on *climate change mitigation, adaptation*, impact reduction and early warning',
      },
      {
        id: 115,
        sdgId: 13,
        externalId: 'a',
        label:
          'Implement the commitment undertaken by developed-country parties to the United Nations Framework Convention on Climate Change to a goal of mobilizing jointly $100 billion annually by 2020 from all sources to address the needs of developing countries in the context of meaningful mitigation actions and transparency on implementation and fully operationalize the Green Climate Fund through its capitalization as soon as possible',
      },
      {
        id: 116,
        sdgId: 13,
        externalId: 'b',
        label:
          'Promote mechanisms for *raising capacity for effective climate change-related planning* and management in least developed countries and small island developing States, including focusing on women, youth and local and marginalized communities * Acknowledging that the United Nations Framework Convention on Climate Change is the primary international, intergovernmental forum for negotiating the global response to climate change.',
      },
    ],
  },
  14: {
    id: 14,
    title:
      '*Conserve and sustainably use the oceans, seas and marine resources for sustainable development*',
    short: 'Life Below Water',
    colorInfo: {
      hex: '#0a97d9',
      rgb: [10, 151, 217],
    },
    keywords: {
      tags: ['oceans', 'seas', 'marine resources'],
      descriptions: [
        'marine ecosystems',
        'coastal ecosystems',
        'marine pollution',
      ],
      groups: [
        'small islands developing States',
        'SIDS',
        'least developed countries',
        'LDCs',
      ],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_14.png',
    targets: [
      {
        id: 117,
        sdgId: 14,
        externalId: 1,
        label:
          'By 2025, prevent and significantly *reduce marine pollution* of all kinds, in particular from land-based activities, including marine debris and nutrient pollution',
      },
      {
        id: 118,
        sdgId: 14,
        externalId: 2,
        label:
          'By 2020, sustainably manage and *protect marine and coastal ecosystems* to avoid significant adverse impacts, including by strengthening their resilience, and take action for their restoration in order to achieve healthy and productive oceans',
      },
      {
        id: 119,
        sdgId: 14,
        externalId: 3,
        label:
          'Minimize and *address the impacts of ocean acidification*, including through enhanced scientific cooperation at all levels',
      },
      {
        id: 120,
        sdgId: 14,
        externalId: 4,
        label:
          'By 2020, effectively *regulate harvesting and end overfishing*, illegal, unreported and unregulated fishing and destructive fishing practices and implement science-based management plans, in order to restore fish stocks in the shortest time feasible, at least to levels that can produce maximum sustainable yield as determined by their biological characteristics',
      },
      {
        id: 121,
        sdgId: 14,
        externalId: 5,
        label:
          'By 2020, *conserve at least 10 per cent of coastal and marine areas*, consistent with national and international law and based on the best available scientific information',
      },
      {
        id: 122,
        sdgId: 14,
        externalId: 6,
        label:
          'By 2020, prohibit certain forms of fisheries subsidies which contribute to overcapacity and overfishing, eliminate subsidies that contribute to illegal, unreported and unregulated fishing and refrain from introducing new such subsidies, recognizing that appropriate and effective special and differential treatment for developing and least developed countries should be an integral part of the World Trade Organization fisheries subsidies negotiation',
      },
      {
        id: 123,
        sdgId: 14,
        externalId: 7,
        label:
          'By 2030, *increase the economic benefits to Small Island developing States* and least developed countries from the sustainable use of marine resources, including through sustainable management of fisheries, aquaculture and tourism',
      },
      {
        id: 124,
        sdgId: 14,
        externalId: 'a',
        label:
          'Increase scientific knowledge, *develop research capacity and transfer marine technology*, taking into account the Intergovernmental Oceanographic Commission Criteria and Guidelines on the Transfer of Marine Technology, in order to improve ocean health and to enhance the contribution of marine biodiversity to the development of developing countries, in particular small island developing States and least developed countries',
      },
      {
        id: 125,
        sdgId: 14,
        externalId: 'b',
        label:
          'Provide *access for small-scale artisanal fishers to marine resources and markets*',
      },
      {
        id: 126,
        sdgId: 14,
        externalId: 'c',
        label:
          'Enhance the conservation and *sustainable use of oceans and their resources* by implementing international law as reflected in UNCLOS, which provides the legal framework for the conservation and *sustainable use of oceans and their resources*, as recalled in paragraph 158 of The Future We Want',
      },
    ],
  },
  15: {
    id: 15,
    title:
      '*Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, *combat desertification*, and halt and reverse land degradation and halt biodiversity loss*',
    short: 'Life on Land',
    colorInfo: {
      hex: '#56c02b',
      rgb: [86, 192, 43],
    },
    keywords: {
      tags: [
        'terrestrial ecosystems',
        'forests',
        'desertification',
        'land',
        'biodiversity',
      ],
      descriptions: ['degraded lands', 'forest management', 'natural habitats'],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_15.png',
    targets: [
      {
        id: 127,
        sdgId: 15,
        externalId: 1,
        label:
          'By 2020, ensure the conservation, restoration and *sustainable use of terrestrial and inland freshwater ecosystems* and their services, in particular forests, wetlands, mountains and drylands, in line with obligations under international agreements',
      },
      {
        id: 128,
        sdgId: 15,
        externalId: 2,
        label:
          'By 2020, promote the implementation of *sustainable management of all types of forests*, halt deforestation, restore degraded forests and substantially increase afforestation and reforestation globally',
      },
      {
        id: 129,
        sdgId: 15,
        externalId: 3,
        label:
          'By 2030, *combat desertification*, restore degraded land and soil, including land affected by desertification, drought and floods, and strive to achieve a land degradation-neutral world',
      },
      {
        id: 130,
        sdgId: 15,
        externalId: 4,
        label:
          'By 2030, ensure the *conservation of mountain ecosystems*, including their biodiversity, in order to enhance their capacity to provide benefits that are essential for sustainable development',
      },
      {
        id: 131,
        sdgId: 15,
        externalId: 5,
        label:
          'Take urgent and significant action to *reduce the degradation of natural habitats, halt the loss of biodiversity* and, by 2020, protect and prevent the extinction of threatened species',
      },
      {
        id: 132,
        sdgId: 15,
        externalId: 6,
        label:
          'Promote fair and equitable sharing of the benefits arising from the *utilization of genetic resources* and promote appropriate access to such resources, as internationally agreed',
      },
      {
        id: 133,
        sdgId: 15,
        externalId: 7,
        label:
          'Take urgent action to *end poaching and trafficking of protected species of flora and fauna* and address both demand and supply of illegal wildlife products',
      },
      {
        id: 134,
        sdgId: 15,
        externalId: 8,
        label:
          'By 2020, introduce measures to prevent the introduction and significantly *reduce the impact of invasive alien species on land and water ecosystems* and control or eradicate the priority species',
      },
      {
        id: 135,
        sdgId: 15,
        externalId: 9,
        label:
          'By 2020, *integrate ecosystem and biodiversity values* into national and local planning, development processes, poverty reduction strategies and accounts',
      },
      {
        id: 136,
        sdgId: 15,
        externalId: 'a',
        label:
          'Mobilize and significantly increase financial resources from all sources to *conserve and sustainably use biodiversity and ecosystems*',
      },
      {
        id: 137,
        sdgId: 15,
        externalId: 'b',
        label:
          'Mobilize significant resources from all sources and at all levels to *finance sustainable forest management* and provide adequate incentives to developing countries to advance such management, including for conservation and reforestation',
      },
      {
        id: 138,
        sdgId: 15,
        externalId: 'c',
        label:
          'Enhance global support for efforts to combat poaching and trafficking of protected species, including by increasing the capacity of local communities to *pursue sustainable livelihood opportunities*',
      },
    ],
  },
  16: {
    id: 16,
    title:
      '*Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels*',
    short: 'Peace and Justice - Strong Institutions',
    colorInfo: {
      hex: '#00689d',
      rgb: [0, 104, 157],
    },
    keywords: {
      tags: [
        'peaceful societies',
        'inclusive societies',
        'justice',
        'institutions',
      ],
      descriptions: [
        'human rights',
        'rule of law',
        'violence',
        'armed conflict',
        'weak institutions',
      ],
      groups: [],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_16.png',
    targets: [
      {
        id: 139,
        sdgId: 16,
        externalId: 1,
        label:
          'Significantly *reduce all forms of violence and related death rates* everywhere',
      },
      {
        id: 140,
        sdgId: 16,
        externalId: 2,
        label:
          '*End abuse, exploitation, trafficking* and all forms of violence against and torture of children',
      },
      {
        id: 141,
        sdgId: 16,
        externalId: 3,
        label:
          '*Promote the rule of law* at the national and international levels and ensure equal access to justice for all',
      },
      {
        id: 142,
        sdgId: 16,
        externalId: 4,
        label:
          'By 2030, significantly *reduce illicit financial and arms flows*, strengthen the recovery and return of stolen assets and combat all forms of organized crime',
      },
      {
        id: 143,
        sdgId: 16,
        externalId: 5,
        label:
          'Substantially *reduce corruption and bribery* in all their forms',
      },
      {
        id: 144,
        sdgId: 16,
        externalId: 6,
        label:
          'Develop *effective, accountable and transparent institutions* at all levels',
      },
      {
        id: 145,
        sdgId: 16,
        externalId: 7,
        label:
          'Ensure responsive, inclusive, participatory and *representative decision-making* at all levels',
      },
      {
        id: 146,
        sdgId: 16,
        externalId: 8,
        label:
          'Broaden and strengthen the *participation of developing countries in the institutions of global governance*',
      },
      {
        id: 147,
        sdgId: 16,
        externalId: 9,
        label:
          'By 2030, *provide legal identity for all*, including birth registration',
      },
      {
        id: 148,
        sdgId: 16,
        externalId: 10,
        label:
          'Ensure *public access to information and protect fundamental freedoms*, in accordance with national legislation and international agreements',
      },
      {
        id: 149,
        sdgId: 16,
        externalId: 'a',
        label:
          '*Strengthen relevant national institutions*, including through international cooperation, for building capacity at all levels, in particular in developing countries, to prevent violence and combat terrorism and crime',
      },
      {
        id: 150,
        sdgId: 16,
        externalId: 'b',
        label:
          '*Promote and enforce non-discriminatory laws and policies* for sustainable development',
      },
    ],
  },
  17: {
    id: 17,
    title:
      '*Strengthen the means of implementation and revitalize the global partnership for sustainable development*',
    short: 'Partnerships for the Goals',
    colorInfo: {
      hex: '#19486a',
      rgb: [25, 72, 106],
    },
    keywords: {
      tags: ['means of implementation', 'partnerships'],
      descriptions: ['resource mobilization'],
      groups: ['developing countries', 'LDCs'],
    },
    icon_url:
      'https://raw.githubusercontent.com/UNStats-SDGs/sdgs-data/master/images/en/TGG_Icon_Color_17.png',
    targets: [
      {
        id: 151,
        sdgId: 17,
        externalId: 1,
        label:
          '*Strengthen domestic resource mobilization*, including through international support to developing countries, to improve domestic capacity for tax and other revenue collection',
      },
      {
        id: 152,
        sdgId: 17,
        externalId: 2,
        label:
          'Developed countries to implement fully their official *development assistance commitments*, including the commitment by many developed countries to achieve the target of 0.7 per cent of ODA/GNI to developing countries and 0.15 to 0.20 per cent of ODA/GNI to least developed countries; ODA providers are encouraged to consider setting a target to provide at least 0.20 per cent of ODA/GNI to least developed countries',
      },
      {
        id: 153,
        sdgId: 17,
        externalId: 3,
        label:
          'Mobilize additional *financial resources for developing countries* from multiple sources',
      },
      {
        id: 154,
        sdgId: 17,
        externalId: 4,
        label:
          '*Assist developing countries in attaining long-term debt sustainability* through coordinated policies aimed at fostering debt financing, debt relief and debt restructuring, as appropriate, and address the external debt of highly indebted poor countries to *reduce* debt distress',
      },
      {
        id: 155,
        sdgId: 17,
        externalId: 5,
        label:
          'Adopt and implement *investment promotion regimes for least developed countries*',
      },
      {
        id: 156,
        sdgId: 17,
        externalId: 6,
        label:
          'Enhance North-South, South-South and triangular *regional and international cooperation* on and access to science, technology and innovation and enhance knowledge sharing on mutually agreed terms, including through improved coordination among existing mechanisms, in particular at the United Nations level, and through a global technology facilitation mechanism',
      },
      {
        id: 157,
        sdgId: 17,
        externalId: 7,
        label:
          '*Promote the development, transfer, dissemination and diffusion of environmentally sound technologies* to developing countries on favourable terms, including on concessional and preferential terms, as mutually agreed',
      },
      {
        id: 158,
        sdgId: 17,
        externalId: 8,
        label:
          'Fully operationalize the technology bank and science, technology and *innovation capacity-building mechanism for least developed countries* by 2017 and enhance the use of enabling technology, in particular information and communications technology',
      },
      {
        id: 159,
        sdgId: 17,
        externalId: 9,
        label:
          'Enhance international support for implementing effective and *targeted capacity-building in developing countries* to support national plans to implement all the sustainable development goals, including through North-South, South-South and triangular cooperation',
      },
      {
        id: 160,
        sdgId: 17,
        externalId: 10,
        label:
          'Promote a universal, rules-based, open, *non-discriminatory and equitable multilateral trading system* under the World Trade Organization, including through the conclusion of negotiations under its Doha Development Agenda',
      },
      {
        id: 161,
        sdgId: 17,
        externalId: 11,
        label:
          'Significantly *increase the exports of developing countries*, in particular with a view to doubling the least developed countries’ share of global exports by 2020',
      },
      {
        id: 162,
        sdgId: 17,
        externalId: 12,
        label:
          'Realize timely implementation of *duty-free and quota-free market access on a lasting basis for all least developed countries*, consistent with World Trade Organization decisions, including by ensuring that preferential rules of origin applicable to imports from least developed countries are transparent and simple, and contribute to facilitating market access',
      },
      {
        id: 163,
        sdgId: 17,
        externalId: 13,
        label:
          'Enhance *global macroeconomic stability*, including through policy coordination and policy coherence',
      },
      {
        id: 164,
        sdgId: 17,
        externalId: 14,
        label: 'Enhance *policy coherence for sustainable development*',
      },
      {
        id: 165,
        sdgId: 17,
        externalId: 15,
        label:
          '*Respect each country’s policy space and leadership* to establish and implement policies for poverty eradication and sustainable development Multi-stakeholder partnerships',
      },
      {
        id: 166,
        sdgId: 17,
        externalId: 16,
        label:
          '*Enhance the global partnership for sustainable development*, complemented by multi-stakeholder partnerships that mobilize and share knowledge, expertise, technology and financial resources, to support the achievement of the sustainable development goals in all countries, in particular developing countries',
      },
      {
        id: 167,
        sdgId: 17,
        externalId: 17,
        label:
          'Encourage and promote *effective public, public-private and civil society partnerships*, building on the experience and resourcing strategies of partnerships Data, monitoring and accountability',
      },
      {
        id: 168,
        sdgId: 17,
        externalId: 18,
        label:
          'By 2020, enhance *capacity-building support to developing countries*, including for least developed countries and small island developing States, to increase significantly the availability of high-quality, timely and reliable data disaggregated by income, gender, age, race, ethnicity, migratory status, disability, geographic location and other characteristics relevant in national contexts',
      },
      {
        id: 169,
        sdgId: 17,
        externalId: 19,
        label:
          'By 2030, build on existing initiatives to *develop measurements of progress on sustainable development* that complement gross domestic product, and support statistical capacity-building in developing countries',
      },
    ],
  },
}
